import React from 'react';

export default () => {
    return (
        <span>Executive Summary</span>
    )
}